const LOGOS = [
  "Google Ads",
  "Meta Business",
  "TikTok Ads",
  "GA4",
  "Looker Studio",
  "Shopify",
  "HubSpot",
  "Klaviyo",
  "Mailchimp",
  "Webflow",
];

const LogoBar = () => {
  return (
    <section data-testid="logo-bar" className="py-10 border-y border-slate-200 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-center text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-6">
          Lucrăm cu platformele care contează
        </p>
        <div className="relative overflow-hidden no-scrollbar">
          <div className="flex gap-12 animate-marquee whitespace-nowrap">
            {[...LOGOS, ...LOGOS].map((name, i) => (
              <span
                key={i}
                className="font-display text-2xl font-bold text-slate-400 hover:text-magenta transition-colors"
              >
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoBar;
